'use client';
import styled, { css } from 'styled-components';

export const StyledHeroStats = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 100px;

  ${props =>
    props.$transparent
      ? css`
          background-color: transparent;
          color: ${props => props.theme.colors.get(props.$fontColor)};
          justify-content: center;
          gap: ${props => props.theme.spacing(8)};
        `
      : css`
          justify-content: space-around;
          background-color: ${props.theme.colors.get(
            props.$backgroundColor,
            props.theme.colors.background.base,
          )};
          color: ${props.theme.colors.text.primary};
        `}
`;

export const StatsBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  width: ${props => (props.$transparent ? 'auto' : 100 / props.$statCount)}%;
  gap: ${props => props.theme.spacing(1)};
`;

export const StatValue = styled.p`
  ${props =>
    props.$transparent
      ? props.theme.typography.heading1
      : props.theme.typography.heading5};
  ${props =>
    props.$transparent
      ? props.theme.fontFamily.newSpirit
      : props.theme.fontFamily.base};
  font-weight: ${props => !props.$transparent && 700};
`;

export const StatLabel = styled.p`
  text-align: center;
  ${props =>
    props.$transparent
      ? props.theme.typography.largeBody
      : props.theme.typography.label};

  color: ${props =>
    props.$transparent ? 'inherit' : props.theme.colors.text.tertiary};
`;

export const Divider = styled.div`
  width: 1px;
  height: 64px;
  background-color: ${props =>
    props.$transparent
      ? props.theme.colors.background.base
      : props.theme.colors.text.tertiary};
  opacity: 0.25;
`;
